import { css } from 'styled-components';

export const h1 = css`
  font-size: 24px;
  line-height: 32px;
  font-weight: 400;
  font-family: 'Playfair Display', serif;
`;

export const h2 = css`
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  font-family: 'Playfair Display', serif;
`;

export const h3 = css`
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  font-family: 'Jost', sans-serif;
`;

export const body = css`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  font-family: 'Jost', sans-serif;
`;

export const h5 = css`
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  font-family: 'Jost', sans-serif;
`;
